(() => {
if (customElements.get('em-compact-reviews')) return;
class EmCompactReviews extends HTMLElement {
  connectedCallback() {
    if (this.listening) return;
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
    this.handleHashChange = this.handleHashChange.bind(this);
    this.handleToggle = this.handleToggle.bind(this);

    document.addEventListener('click', this.handleDocumentClick, true);
    document.addEventListener('keydown', this.handleDocumentKeydown, true);
    window.addEventListener('hashchange', this.handleHashChange);
    this.details.addEventListener('toggle', this.handleToggle);
    this.listening = true;
    this.handleHashChange();
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick, true);
    document.removeEventListener('keydown', this.handleDocumentKeydown, true);
    window.removeEventListener('hashchange', this.handleHashChange);
    this.details?.removeEventListener('toggle', this.handleToggle);
    window.clearTimeout(this.scrollTimer);
    this.listening = false;
  }

  isTrigger(target) {
    if (!(target instanceof Element) || this.contains(target)) return false;
    const badge = target.closest('.jdgm-prev-badge, .jdgm-preview-badge');
    if (badge?.closest('.cc-main-product .product-info')) return true;
    const link = target.closest('a[href]');
    if (!link) return false;
    const url = new URL(link.href, window.location.href);
    return url.origin === window.location.origin && url.pathname === window.location.pathname
      && (url.hash === '#bewertungen' || url.hash.includes('judgeme_product_reviews'));
  }

  openAndScroll() {
    this.details.open = true;
    // Run after the review app's own click listener has finished.
    window.clearTimeout(this.scrollTimer);
    this.scrollTimer = window.setTimeout(() => {
      if (!this.isConnected) return;
      this.details.querySelector('summary')?.focus({ preventScroll: true });
      this.details.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }, 0);
  }

  handleDocumentClick(event) {
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !this.isTrigger(event.target)) return;
    event.preventDefault();
    this.openAndScroll();
  }

  handleDocumentKeydown(event) {
    if (!['Enter', ' '].includes(event.key) || !this.isTrigger(event.target)) return;
    // Native links/buttons already synthesize a click from the keyboard.
    if (event.target.closest('a, button')) return;
    event.preventDefault();
    this.openAndScroll();
  }

  handleHashChange() {
    if (window.location.hash === '#bewertungen' || window.location.hash.includes('judgeme_product_reviews')) {
      this.openAndScroll();
    }
  }

  handleToggle() {
    if (this.details.open) {
      window.setTimeout(() => window.dispatchEvent(new Event('resize')), 80);
    }
  }
}

if (!customElements.get('em-compact-reviews')) {
  customElements.define('em-compact-reviews', EmCompactReviews);
}
})();
